var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-btn',{staticClass:"text-none pb-2",attrs:{"flat":""},on:{"click":function($event){return _vm.download()}}},[_c('v-icon',{staticClass:"mr-1",attrs:{"small":""}},[_vm._v(" description ")]),_vm._v(_vm._s(_vm.name))],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7855788c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/BtnDownloadExcel.vue
// module id = null
// module chunks = 